import OrderListComponent from 'src/components/features/superAdmin/orderListComponent';

const ListOrderPage = () => <OrderListComponent />;

export default ListOrderPage;